/*
 * SK Hero background video.
 * Lazy-loads on viewport intersection, plays muted in loop.
 * HLS: native on Safari, hls.js (theme asset) on other browsers.
 * Falls back to <source> MP4 when HLS fails or is unavailable.
 * Respects prefers-reduced-motion (keeps the poster image).
 */
(function () {
  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function reveal(video) {
    video.classList.add('is-playing');
  }

  function tryMp4Fallback(video) {
    video.removeAttribute('src');
    var sources = video.querySelectorAll('source');
    if (!sources.length) return false;
    video.load();
    play(video);
    return true;
  }

  function startNativeHls(video, url) {
    video.src = url;
    video.load();
    play(video);
  }

  function startHlsJs(video, url) {
    var Hls = window.Hls;
    if (!Hls || !Hls.isSupported()) {
      return tryMp4Fallback(video);
    }

    var h = new Hls({ capLevelToPlayerSize: true, enableWorker: true });
    video._skHls = h;
    h.loadSource(url);
    h.attachMedia(video);
    h.on(Hls.Events.MANIFEST_PARSED, function () {
      play(video);
    });
    h.on(Hls.Events.ERROR, function (_event, data) {
      if (!data.fatal) return;
      h.destroy();
      video._skHls = null;
      if (!tryMp4Fallback(video)) {
        video.classList.remove('is-playing');
      }
    });
  }

  function start(video) {
    if (video.dataset.skInit) return;
    video.dataset.skInit = '1';
    video.muted = true;

    var hlsUrl = video.getAttribute('data-hls');
    video.addEventListener('playing', function () {
      reveal(video);
    }, { once: true });

    if (!hlsUrl) {
      video.load();
      play(video);
      return;
    }

    // Safari / iOS: native HLS
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      startNativeHls(video, hlsUrl);
      video.addEventListener('error', function () {
        if (!tryMp4Fallback(video)) video.classList.remove('is-playing');
      }, { once: true });
      return;
    }

    // Chrome / Firefox / Edge: hls.js (bundled in theme assets)
    if (window.MediaSource) {
      if (window.Hls) {
        startHlsJs(video, hlsUrl);
      } else {
        // hls.min.js still loading — retry briefly
        var attempts = 0;
        var wait = setInterval(function () {
          attempts += 1;
          if (window.Hls) {
            clearInterval(wait);
            startHlsJs(video, hlsUrl);
          } else if (attempts > 40) {
            clearInterval(wait);
            tryMp4Fallback(video);
          }
        }, 50);
      }
      return;
    }

    tryMp4Fallback(video);
  }

  function isNearViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom >= -200 && r.top <= window.innerHeight + 200;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll('[data-sk-hero-video]');
    if (!videos.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, start);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          start(e.target);
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '200px' });

    Array.prototype.forEach.call(videos, function (v) {
      if (isNearViewport(v)) {
        start(v);
      } else {
        io.observe(v);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
